// extracted by mini-css-extract-plugin
module.exports = {"post_card":"PostCard_post_card__3iJuC","title":"PostCard_title__1xNgk","cancel_button":"PostCard_cancel_button__mRC8a"};